import { useNavigate } from "react-router-dom";
import { RolesEnum } from "../../../enums/roles";
import { TipoClienteEnum } from "../../../enums/tipoCliente";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { useUserPermissions } from "../../../hooks/useUserPermissions";
import { getEmpresa } from "../../../utils/getEmpresa";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";

export const useHomeV2 = () => {
  const navigate = useNavigate();
  const [token] = useSessionStorage("@token");
  const { hasRole, isUserType } = useUserPermissions();
  const stepIndicator = useAgendamentoStepIndicator("hidden md:flex");

  const isCliente = hasRole(RolesEnum.ROLE_CLIENTE);
  const isDespachante = isUserType(TipoClienteEnum.DESPACHANTE);
  const mostrarItinerante = Boolean(token) && isDespachante;
  const empresa = getEmpresa(process.env.REACT_APP_PROJECT as string);

  const destinoLoja = isCliente ? "/agendamento/loja" : "/novo-agendamento";
  const destinoDomicilio = isCliente
    ? "/agendamento/domicilio"
    : "/novo-agendamento";
  const destinoItinerante = "/agendamento/itinerantes";

  const handleLoja = () => navigate(destinoLoja);
  const handleDomicilio = () => navigate(destinoDomicilio);
  const handleItinerante = () => navigate(destinoItinerante);

  return {
    empresa,
    mostrarItinerante,
    handleLoja,
    handleDomicilio,
    handleItinerante,
    stepIndicator,
  };
};
